export default "__VITE_ASSET__S8QOtjm7__"